// Browser capability/cleanup boundary. No game or wallet business decisions.
export function bindMobileGameSession(element, { documentObject = document } = {}) {
  let closed = false;
  const doc = documentObject;
  const lobby = doc.getElementById('root');
  const previous = { inert: lobby?.inert, focus: doc.activeElement,
    bodyOverflow: doc.body.style.overflow, htmlOverflow: doc.documentElement.style.overflow };
  const fullscreenElement = () => doc.fullscreenElement || doc.webkitFullscreenElement;
  const safe = (operation) => { try { return Promise.resolve(operation()).catch(() => false); } catch { return Promise.resolve(false); } };
  const exitFullscreen = () => {
    if (fullscreenElement() === element) return safe(() => (doc.exitFullscreen || doc.webkitExitFullscreen)?.call(doc));
    return Promise.resolve(false);
  };
  if (lobby) lobby.inert = true;
  doc.body.style.overflow = 'hidden';
  doc.documentElement.style.overflow = 'hidden';
  element.focus({ preventScroll: true });
  const requestFullscreen = () => {
    if (closed) return Promise.resolve(false);
    return safe(() => (element.requestFullscreen || element.webkitRequestFullscreen)?.call(element))
      .then(() => closed ? exitFullscreen() : fullscreenElement() === element);
  };
  return {
    requestFullscreen,
    cleanup() {
      if (closed) return;
      closed = true;
      if (lobby) lobby.inert = previous.inert;
      doc.body.style.overflow = previous.bodyOverflow;
      doc.documentElement.style.overflow = previous.htmlOverflow;
      void exitFullscreen();
      previous.focus?.focus?.({ preventScroll: true });
    },
  };
}
